import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import {getRangeMixingSpeedPipettingParameter} from 'stores/business/pipettingParameterBusiness';
import {parseMessage} from 'lib/stringHelper';
import {TaskType} from 'constants/dataEnum';
import {PipettingProfileItemWrapper} from '../PipettingProfileWrapper';
import PipettingProfileInputType from '../PipettingProfileInputType';

function PipettingItemMixingSpeed({task, onChange}) {
  const dispatch = useDispatch();
  const {type, mixingSpeed} = task;

  const rangeMixingSpeed = dispatch(getRangeMixingSpeedPipettingParameter(task));

  const getLabelText = () => {
    let label = parseMessage('protocolEditor.taskList.pipettingProfile.mixingSpeedDispense', {
      volumeLimits: `${rangeMixingSpeed?.minValue} - ${rangeMixingSpeed?.maxValue}`,
    });

    if (type === TaskType.MIXING) {
      label = parseMessage('protocolEditor.taskList.pipettingProfile.mixingSpeed', {
        volumeLimits: `${rangeMixingSpeed?.minValue} - ${rangeMixingSpeed?.maxValue}`,
      });
    } else if (type === TaskType.ASPIRATE) {
      label = parseMessage('protocolEditor.taskList.pipettingProfile.mixingSpeedAspirate', {
        volumeLimits: `${rangeMixingSpeed?.minValue} - ${rangeMixingSpeed?.maxValue}`,
      });
    }

    return label;
  };

  return (
    <PipettingProfileItemWrapper>
      <div style={{display: 'flex', flexDirection: 'row'}}>
        <li />
        {getLabelText()}
      </div>
      <PipettingProfileInputType.NumericTextBox
        value={mixingSpeed}
        minValue={rangeMixingSpeed?.minValue}
        maxValue={rangeMixingSpeed?.maxValue}
        onChange={(value) => onChange(value, type)}
      />
      <PipettingProfileInputType.Unit.MicroLiterPerSec />
    </PipettingProfileItemWrapper>
  );
}

PipettingItemMixingSpeed.propTypes = {
  onChange: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
};

export default PipettingItemMixingSpeed;
